import { useEffect, useState } from 'react';

const STORAGE_KEY = 'wcfantasy.pwa-dismissed';

export default function PWAInstallBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      if (localStorage.getItem(STORAGE_KEY)) return;
    } catch {}
    const standalone = window.matchMedia?.('(display-mode: standalone)').matches
      || (navigator as any).standalone === true;
    if (standalone) return;
    const ua = navigator.userAgent.toLowerCase();
    const isIOS = /iphone|ipad|ipod/.test(ua);
    if (!isIOS && !('serviceWorker' in navigator)) return;
    const timer = setTimeout(() => setVisible(true), 4000);
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  function dismiss() {
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch {}
    setVisible(false);
  }

  return (
    <div
      className="lg:hidden fixed bottom-[4.75rem] inset-x-2 z-30 card p-3 ring-1 ring-pitch-500/30 shadow-glow"
      style={{ marginBottom: 'env(safe-area-inset-bottom)' }}
    >
      <div className="flex items-start gap-2">
        <div className="flex-1 min-w-0">
          <div className="text-sm font-semibold">{'Add to home screen'}</div>
          <p className="text-[11px] text-dim mt-0.5">{'Install the app to get lock-screen push notifications and a fullscreen experience.'}</p>
          <p className="text-[10px] text-dim mt-1">Safari → Share → Add to Home Screen</p>
        </div>
        <button onClick={dismiss} className="text-dim text-xl leading-none px-1">×</button>
      </div>
    </div>
  );
}
